import React from 'react'
// import { getOrderStatusLabel } from '@@partner:helpers/order'

import { Tag } from 'rsuite'

export interface CommonStatusLabelProps {
  status: number
}

export const getCommonStatusLabel = (status: number) => {
  switch (status) {
  case -1:
    return {
      label: 'Недоступно',
      color: 'gray'
    }
  case 0:
    return {
      label: 'Отключен до синхронизации',
      color: 'yellow'
    }
  case 1:
    return {
      label: 'Активно',
      color: 'green'
    }
  default:
    return {
      label: 'Неизвестный статус',
      color: 'violet'
    }
  }
}

export default function CommonStatusLabel ({ status }: CommonStatusLabelProps) {
  const { label, color = null } = getCommonStatusLabel(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
